function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .svg-home {\n                fill: #fff\n            }\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons_Top_copy",
  "data-name": "Icons Top copy"
}, /*#__PURE__*/React.createElement("path", {
  className: "svg-home",
  d: "M28.71,30H20.55a.73.73,0,0,1-.73-.72V21.05H14.54v8.23a.72.72,0,0,1-.72.72H5.66a.72.72,0,0,1-.72-.72V16.83H.72a.72.72,0,0,1-.67-.46.71.71,0,0,1,.18-.79L16.69.19a.75.75,0,0,1,1,0L34.14,15.58a.75.75,0,0,1,.18.79.73.73,0,0,1-.68.46H29.43V29.28A.72.72,0,0,1,28.71,30Zm-7.44-1.44H28V16.11a.73.73,0,0,1,.73-.72h3.1L17.18,1.71,2.55,15.39H5.66a.72.72,0,0,1,.72.72V28.56H13.1V20.33a.72.72,0,0,1,.72-.72h6.73a.72.72,0,0,1,.72.72Z"
})));

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34.37 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.e3ab60ab.svg";
export { ForwardRef as ReactComponent };